<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="用户名称"
                clearable
                v-model.trim="userName"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="操作模块"
                clearable
                v-model.trim="title"
                size="mini"
              >
              </el-input>
            </div>
          </div>

          <div class="item">
            <el-button
              type="primary"
              @click="handleSearch({ page: 1 })"
              size="mini"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="700">
        <el-table-column label="ID" prop="id" />
        <el-table-column label="用户id" prop="userId" />
        <el-table-column label="用户名称" prop="userName" />
        <el-table-column label="ip" prop="operIp" />
        <el-table-column label="操作模块" prop="title" />
        <el-table-column label="请求方式" prop="method" />
        <el-table-column label="请求url" prop="operUrl" />
        <el-table-column
          label="请求参数"
          prop="operParam"
          :show-overflow-tooltip="true"
          align="center"
        />
        <el-table-column prop="" label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | moment }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="total"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </pagination>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api.js";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tabList: [],
      total: 0,
      title: "",
      userName: "",
      pagination: {
        page: 1,
        size: 25,
      },
    };
  },
  computed: {},
  mounted() {
    this.handleSearch();
  },
  methods: {
    handleSearch(data = {}) {
      api
        .getUserList({
          ...this.pagination,
          ...data,
          userName: this.userName,
          title: this.title,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data;
            this.tabList = list;
            this.total = totalCount;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style lang="less" scoped></style>
